import * as z from "zod";
import { carrierClaimsDimensionSchema } from "./carrier-claims-analytics-common";

export const getCarrierClaimsFilterOptions = {
  name: "getCarrierClaimsFilterOptions" as const,
  input: z.null(),
  output: z.object({
    carriers: z.array(carrierClaimsDimensionSchema),
    teams: z.array(carrierClaimsDimensionSchema),
  }),
};

export type GetCarrierClaimsFilterOptionsOutput = z.infer<
  typeof getCarrierClaimsFilterOptions.output
>;
